import { Component, OnInit } from '@angular/core';
import { EmbeddingContext, createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { StatisticheApiService } from 'src/api/statistiche-api.service';

@Component({
  selector: 'app-quicksight',
  templateUrl: './quicksight.component.html',
  styleUrls: ['./quicksight.component.css']
})
export class QuicksightComponent  implements OnInit{
  
  constructor(private http: StatisticheApiService) { }

loadingError = false;
dashboard: any;

ngOnInit() {
  this.getDashboardURL();
}

public async getDashboardURL() {
  this.http.getQuickLink()
  .then((data: any) => {console.log(data.embedUrl);this.Dashboard(data.embedUrl)})
  .catch((error: any) => {
    this.loadingError = true;
    console.error('Error fetching dashboard URL:', error);
  });
}

public async Dashboard(embeddedURL: any) {
  const containerDiv = document.getElementById("dashboardContainer") || '';
  const frameOptions = {
    url: embeddedURL,
    container: containerDiv,
    height: "850px",
    width: "100%",
    resizeHeightOnSizeChangedEvent: true,
}
  const embeddingContext: EmbeddingContext = await createEmbeddingContext();
  this.dashboard = embeddingContext.embedDashboard(frameOptions);
}
}